import { useState } from "react";

import logo from "./assets/dwe-logo.png";
import LiffButton from "./components/LiffButton";
import LiffCheckbox from "./components/LiffCheckbox";
import liffClient from "./services/liffClient";

const taiwanRegex = /^09\d{8}$/;

interface PhoneNumberVerificationProps {
  isSubmitting: boolean;
  onSubmit: (phoneNumber: string) => void;
}

export default function PhoneNumberVerification({
  isSubmitting,
  onSubmit,
}: PhoneNumberVerificationProps) {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(false);
  const [agreedToPrivacyPolicy, setAgreedToPrivacyPolicy] = useState(false);

  const isSubmitEnabled =
    isPhoneNumberValid && agreedToPrivacyPolicy && !isSubmitting;

  const handlePhoneNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value.replace(/\D/g, "").slice(0, 10);

    setPhoneNumber(value);
    setIsPhoneNumberValid(taiwanRegex.test(value));
  };

  const handleSubmit = () => {
    if (!isSubmitEnabled) return;

    onSubmit(phoneNumber);
  };

  const handlePrivacyPolicyClick = () => {
    liffClient.openWindow("https://q4u.worldfamily.com.tw/privacy_file.html");
  };

  return (
    <main className="flex flex-1 flex-col items-center pb-10 pt-[72px]">
      <img
        src={logo}
        alt="Disney World of English 迪士尼美語世界"
        className="min-h-[96px] min-w-[362px]"
      />

      <p className="mt-12 text-[38px] font-bold leading-[48px]">帳號綁定</p>

      <p className="mt-[60px] text-nowrap text-center text-[32px] font-bold leading-[48px] text-[#0068B7]">
        歡迎來到
        <br />
        Disney World of English
        <br />
        迪士尼美語世界！
      </p>

      <label
        htmlFor="phone-number"
        className="mt-10 text-[24px] font-bold leading-[48px]"
      >
        請驗證您的手機號碼
      </label>

      <input
        id="phone-number"
        type="tel"
        inputMode="numeric"
        maxLength={10}
        placeholder="0912345678"
        value={phoneNumber}
        onChange={handlePhoneNumberChange}
        disabled={isSubmitting}
        className="
          mt-4 box-border h-[60px] w-[340px]
          rounded-[4px] border border-solid border-[#999999]
          bg-white px-6
          text-[24px] font-light text-black
          outline-none
          placeholder:font-light placeholder:text-[#999999]
          focus:border-[#0068B7]
          disabled:cursor-not-allowed
        "
      />

      <LiffButton
        className="mt-8"
        disabled={!isSubmitEnabled}
        onClick={handleSubmit}
      >
        {isSubmitting ? "發送中..." : "發送驗證碼"}
      </LiffButton>

      <div className="mt-10 flex w-full items-start gap-2">
        <LiffCheckbox
          checked={agreedToPrivacyPolicy}
          onCheckedChange={setAgreedToPrivacyPolicy}
        />

        <p className="flex-1 text-[20px] font-light leading-[30px] text-black">
          我已閱讀並同意
          <span
            onClick={handlePrivacyPolicyClick}
            className="cursor-pointer underline"
          >
            隱私權政策
          </span>
          ，並同意將 LINE 帳號與會員帳號進行連結。
        </p>
      </div>
    </main>
  );
}
